module.exports = __webpack_public_path__ + "media/images/admin/icons/pie-chart-8359ca2bd0c76759b6d82c1065740642.svg";